import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class WidgetNavigation extends ClickElement {
  value1: string | null = null;
  value2: string | null = null;

  icon: string | null = null;

  iconStyle: string | null = null;

  constructor() {
    super();
    this.elementType = ElementType.widgetNavigation;
  }
}
